import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueAnalytics, {
    id: 'UA-127825367-1',
    debug: {
        enabled: false,
        trace: false,
        sendHitTask: false
    }
});

new Vue({
    render: h => h(App)
}).$mount('#app');
